import useToggleModal from "hooks/useToggleModal";
import MainSetup from "./components/main-setup/MainSetup";
import GetStarted from "./components/get-started";
import SetupWorkflowContextProvider from "./contexts";
import { AmplitudePageName } from "utils/amplitude";

interface Props {
  amplitudePageName: AmplitudePageName;
}

const SetupWorkflow: React.FC<Props> = ({ amplitudePageName }) => {
  // control get started modal show
  const { show, close } = useToggleModal(true);

  // control main set up modal show
  const {
    show: showMain,
    open: openMain,
    close: closeMain,
  } = useToggleModal(false);

  return (
    <SetupWorkflowContextProvider>
      <GetStarted
        show={show}
        onHide={() => {
          close();
        }}
        onNext={() => {
          close();
          openMain();
        }}
        amplitudePageName={amplitudePageName}
      />

      <MainSetup
        show={showMain}
        onHide={closeMain}
        amplitudePageName={amplitudePageName}
      />
    </SetupWorkflowContextProvider>
  );
};

export default SetupWorkflow;
